module.exports = __webpack_public_path__ + "files/51932a79a53812b65f43c24d687b4fef.png";